<template>
  <el-card shadow="never">
    <div class="card-header">
      <span v-if="data.title">{{ data.title }}</span>
      <span v-else>第三方平台</span>
    </div>
    <div class="card-body">
      <div class="card-content" v-if="data.content || data.contentTitle">
        <div class="words">
          <span>{{ data.num + "字" }}</span>
        </div>
        <div class="flex">
          <div class="label">标题</div>
          <div class="articleContent" v-if="data.contentTitle">
            <el-tooltip
              placement="top-start"
              width="200"
              :disabled="data.contentTitle.length < 35"
              trigger="hover"
              :content="data.contentTitle"
            >
              <p>{{ data.contentTitle }}</p>
            </el-tooltip>
          </div>
        </div>
        <div class="flex">
          <div class="label">正文</div>
          <div class="articleContent" v-html="data.content" />
        </div>
      </div>
      <slot></slot>
    </div>
  </el-card>
</template>

<script>
export default {
  name: "cardBody",
  props: ["articleData"],
  data() {
    return {};
  },
  computed: {
    data: {
      get() {
        return this.articleData;
      },
      set(val) {
        this.$emit("update:articleData", val);
      },
    },
  },
  watch: {},
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
:deep(.el-card) {
  border-radius: 0;
  .el-card__body {
    padding: 0;
    border: 0;
    border: 1px solid #e6e6e6;
  }
}
.card-content {
  padding: 10px;
  font-size: 13px;
  height: 68vh;
  > div:nth-child(2) {
    .articleContent {
      p {
        overflow: hidden;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
      }
    }
  }
}
.words {
  overflow: hidden;
  margin-bottom: 5px;
  span {
    float: right;
  }
}
.flex {
  .label {
    min-width: 50px;
    min-height: 34px;
  }
  .articleContent {
    overflow-x: hidden;
    word-break: break-all;
    :deep(p) {
      line-height: 20px;
      word-break: break-all;
      overflow-wrap: anywhere;
    }
  }
  &:last-child {
    margin-top: 10px;
    .articleContent {
      overflow-y: auto;
      height: 57vh;
    }
  }
}
.card-header {
  line-height: 20px;
  padding: 15px;
  text-align: center;
  font-size: 15px;
  color: #7a7a7a;
  background-color: #f7f7f7;
  border-bottom: 1px solid #e6e6e6;
}
.card-body {
  padding: 10px 15px 30px 15px;
  .card-content {
    background-color: #f0f2f5;
  }
}
</style>
